//
//   Background overlay, show/hide based on modal state.
//
//   Entering: "ease-out duration-300"
//     From: "opacity-0"
//     To: "opacity-100"
//   Leaving: "ease-in duration-200"
//     From: "opacity-100"
//     To: "opacity-0"
//
//     Modal panel, show/hide based on modal state.
//
//     Entering: "ease-out duration-300"
// From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
// To: "opacity-100 translate-y-0 sm:scale-100"
// Leaving: "ease-in duration-200"
// From: "opacity-100 translate-y-0 sm:scale-100"
// To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['bgOverlay', 'modal', 'container'];

  open(event) {
    event.preventDefault();
    this.containerTarget.style.display = 'flex';
  }

  close(event) {
    event.preventDefault();
    this.containerTarget.style.display = 'none';
  }
}
